import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type ShareIconProps = CreateIconComponentProps;

export const ShareIcon: React.FC<ShareIconProps> = ({
  title = 'Share',
  viewBox = '0 0 24 24',
  color = 'currentColor',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    {/* prettier-ignore */}
    <><path fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 8H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-2M9 5l3-3 3 3M12 2v12" /></>
  </CreateIconComponent>
);

export default ShareIcon;
